import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ArrowRight_sm = (props) => {
    const width = props.width ? props.width + 'px' : '20px';
    const height = props.height ? props.height + 'px' : '20px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 20 20"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.4697 4.46967C11.7626 4.17678 12.2374 4.17678 12.5303 4.46967L17.5303 9.46967C17.671 9.61032 17.75 9.80109 17.75 10C17.75 10.1989 17.671 10.3897 17.5303 10.5303L12.5303 15.5303C12.2374 15.8232 11.7626 15.8232 11.4697 15.5303C11.1768 15.2374 11.1768 14.7626 11.4697 14.4697L15.1893 10.75L3 10.75C2.58579 10.75 2.25 10.4142 2.25 10C2.25 9.58579 2.58579 9.25 3 9.25L15.1893 9.25L11.4697 5.53033C11.1768 5.23744 11.1768 4.76256 11.4697 4.46967Z"
            />
        </SvgStyled>
    );
};

export default ArrowRight_sm;
